<template>
  <div class="row-login" style="background-color: #f8f8f8">


    <div class="header-log">
      <div class="wp">
        <div class="logo-log">
          <img src="@/assets/images/log/logo2.png" alt="" />
        </div>
        <div class="btns">
          <div class="btn">
            已有账号，<router-link to="/login" class="a">马上登陆</router-link>
          </div>
          <div class="line">|</div>
          <router-link to="/" class="btn a">返回首页</router-link>
        </div>
      </div>
    </div>
    <div class="m-signin1 m-password1">
      <div class="box">
        <div class="top">账号安全</div>
        <div class="inner">
          <!-- 找回密码 -->
         <div class="m-formg1 m-formg2  m-formg3">
           <div class="m-pass1 m-pass2">
             <div class="tit">找回密码</div>
          </div>
            <form action="" onsubmit="return false">
              <div class="form">
                <div class="li li2">
                  <div class="con con-num">
                    <div class="left">
                      <el-select v-model="value" placeholder="请选择">
                        <el-option
                          v-for="item in options"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        >
                        </el-option>
                      </el-select>
                    </div>
                    <div class="inpbox">
                      <el-input
                        placeholder="请输入手机号"
                        v-model="mobile"
                        class="inp"
                      ></el-input>
                    </div>
                  </div>
                </div>
                <div class="li li2">
                  <div class="info">短信验证码</div>
                  <div class="con con-code">
                    <div class="inpbox">
                      <el-input
                        placeholder="请输入短信验证码"
                        v-model="code"
                        class="inp"
                      ></el-input>
                    </div>
                    <div class="btn-code">
                    <button :disabled="isCountingDown" @click="getCaptcha" class="code">获取验证码</button>
                    <p v-if="isCountingDown" class="num">剩余{{ countdown }}秒</p>
                  </div>
                  </div>
                </div>
                <div class="li li3">
                  <div class="info">设置密码</div>
                  <div class="con con-pass">
                    <div class="inpbox">
                      <el-input
                        placeholder="8-20位密码，字母/数字/符号至少2种"
                        v-model="password"
                        show-password
                        class="inp"
                      ></el-input>
                    </div>
                  </div>
                  <div class="con">
                    <div class="inpbox">
                      <el-input
                        placeholder="请再次确认您的密码"
                        v-model="password2"
                        show-password
                        class="inp"
                      ></el-input>
                    </div>
                  </div>
                </div>
              </div>
              <div class="g-btns1" @click="submit">确认修改</div>
            </form>
          </div>
          <!-- 已找回密码 -->
          <!-- <div class="m-pass1">
            <div class="tit">找回密码</div>
            <div class="desc">您已经成功设置密码，请使用新密码登录</div>
          <router-link to="/login" class="g-btns1">马上登录</router-link>
          </div> -->
        </div>
      </div>
      <div class="m-logdw" style="color: #9FA6AF;">
        Copyright ©
        <router-link to="/" class="a">北京智承教育科技有限公司</router-link>
        <router-link to="/" class="a">京ICP备19056005号-1</router-link>
      </div>
    </div>
      <!-- <div class="m-signtips">
        注：注册后返回登录界面登录，首次登录后跳转到“会员中心--我的信息，提醒完善资料”
      </div> -->
    <!-- 弹窗 -->
    <a-modal
      :visible="visible"
      @cancel="handleCancel"
      :footer="null"
      :centered="true"
      :closable="false"
      :width="460"
    >
       <!-- 左侧提示框 -->
    <div class="m-passpop">
      <div class="tit">找回密码</div>
      <div class="desc">您已经成功设置密码，请使用新密码登录</div>
          <router-link to="/login" class="g-btns1">马上登录</router-link>
    </div>
    <!-- 左侧提示框 end -->
    </a-modal>
  </div>
</template>

<script>
import {getApiRes} from "@/api/apiUtil";
import {forgetByUserMobile, sendMobileCode} from "@/api/user";

export default {
  components: {},
  data() {
    return {
      visible: false,
      options: [
        {
          value: "0",
          label: "+86",
        },
        {
          value: "1",
          label: "+87",
        },
      ],
      value: "+86",
      input1: "",
      mobile: "",
      password: "",
      code: "",
      password2: "",
      select: "",
      type: [],
      isCountingDown: false, // 是否正在倒计时
      countdown: 60, // 倒计时秒数
      timer: null, // 定时器
    };
  },
  computed: {},

  mounted() {},

  methods: {
    // 弹窗
    showModal() {
      this.visible = true;
    },
    handleCancel(e) {
      this.visible = false;
    },
    async submit(){
      if(!this.mobile) return this.$message.error('请输入手机号')
      if(!this.code) return this.$message.error('请输入短信验证码')
      if(!this.password) return this.$message.error('请输入密码')
      if(!this.password2) return this.$message.error('请再次输入密码')
      if(this.password!==this.password2) return this.$message.error('两次密码不一致')
      let data = {
        mobile: this.mobile,
        code: this.code,
        password: this.password,
        password2: this.password2
      }
      let re = await getApiRes(forgetByUserMobile(data), 0,1,1,0)
      if(re.code!==0) return
      // this.$message.success('密码重置成功')
      this.showModal()
    },
    async getCaptcha() {
      if (this.isCountingDown) {
        return; // 如果正在倒计时，则不执行获取验证码操作
      }

      if(!this.mobile) return this.$message.error('请输入手机号')
      // 在这里执行获取验证码的操作，比如向服务器发送请求
      let re = await getApiRes(sendMobileCode(this.mobile), 0,1,1,1)
      if(re.code!==0) return

      // 开始倒计时
      this.isCountingDown = true;
      this.timer = setInterval(() => {
        if (this.countdown > 0) {
          this.countdown--;
        } else {
          // 倒计时结束，重置状态
          this.isCountingDown = false;
          this.countdown = 60;
          clearInterval(this.timer); // 清除定时器
        }
      }, 1000);
    },
  },
};
</script>

<style lang="scss" scoped></style>
